import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import { useGoogleOneTapLogin, useGoogleLogin } from "@react-oauth/google";
import { Button } from "@mui/material";

const CLIENT_ID =
  "595097352745-ctqg8lqr18qqr2hc9oohe93dbp94n6fe.apps.googleusercontent.com";

const GoogleLoginModal = ({
  googleSignIn,
  setGooglesignIn,
  onSuccess,
  onFailure,
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setGooglesignIn(false);
  };

  const login = useGoogleLogin({
    onSuccess: onSuccess,
    onError: onFailure,
    flow: "auth-code", // Use authorization code flow
    scope: "https://www.googleapis.com/auth/calendar openid email profile",
  });

  return (
    <Modal
      id="addfollowup"
      show={googleSignIn}
      onHide={handleClose}
      size="sm"
      centered
    >
      <Modal.Header closeButton>
        {/* <Modal.Title>{Lo}</Modal.Title> */}
      </Modal.Header>
      <Modal.Body
        style={{
          justifyContent: "center",
          textAlign: "center",
          background: "#f2f2f2",
        }}
      >
        <GoogleOAuthProvider clientId={CLIENT_ID}>
          <Button
            style={{
              border: "1px solid",
              borderRadius: "50px",
              padding: "10px",
            }}
            onClick={login}
          >
            {" "}
            <img style={{ width: "20px" }} src="/images/google.png" /> Sign in
            with Google{" "}
          </Button>
        </GoogleOAuthProvider>
      </Modal.Body>
    </Modal>
  );
};

export default GoogleLoginModal;
